/**
 * payment/pendingWithdrawals/fetch-pending-withdrawals.js
 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';

const register = dataflow.register;
const state = {
	/* list of pending withdrawals*/
};
let requestUrl = null;
let callbackIfEmpty = null;

function parseToState(data) {
	const arrayHasContent = Boolean(Array.isArray(data) && data.length > 0);
	if (arrayHasContent) {
		state.by_id = {};
		data.forEach((elm) => {
			if (elm.id || elm.id === 0) {
				state.by_id[elm.id] = elm;
			}
		});
	}
	state.empty = !arrayHasContent;
	return arrayHasContent;
}

function getDataAndReplaceState() {
	/* parse and get feedback if exists or not
	 * Make the received data accessible to the other modules
	 * Execute callback to skip pending withdraw step if no pending withdraws */
	function successHandler(data) {
		const pendingExist = parseToState(data);
		actions.fetchPendingWithdrawals(state);
		if (!pendingExist) {
			//Removing the delay to handle seamless transition to further steps
			callbackIfEmpty();
		}
	}

	function errorHandler(err) {
		console.error('fetch_pending_withdrawals:error:', err);
		callbackIfEmpty();
	}

	core.get(requestUrl, successHandler, errorHandler);
}

function registerActions() {
	function fetchPendingWithdrawals(payload) {
		if (payload.type === constants.SETUP_PENDING_WITHDRAWALS) {
			getDataAndReplaceState();
		}
		if (payload.type === constants.FETCH_CANCEL_WITHDRAW) {
			getDataAndReplaceState();
		}
	}
	register(fetchPendingWithdrawals);
}

export default {
	init(url, isEmptyCallback) {
		requestUrl = (url || null);
		callbackIfEmpty = ((typeof isEmptyCallback === 'function') ? isEmptyCallback : function doNothing() {});
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/lib/fetch-pending-withdrawals.js